// plugins/serial-port.js
import {serialPort} from "@/tcode/SerialPortHelper";

export default {
  install(Vue) {
    // 注入到Vue原型
    Vue.prototype.$serialPort = serialPort;

    // 可选：作为全局混入
    Vue.mixin({
      data() {
        return {
          serialPortState: serialPort.state
        };
      },
      created() {
        // 自动响应状态变化
        serialPort.on('state-update', () => {
          this.$forceUpdate();
        });
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/plugin/serial-port.js